import React, {useContext, useEffect, useRef, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {IDepartment, IEmployee, IProject, ISelect} from "../../../models";
import {getBearer} from "../../../functions/getBearer";
import axios from "axios";
import {getApiLink} from "../../../functions/getApiLink";
import {addEmployee, editEmployee} from "../../../storage/toolkit";
import {CustomSelect1} from "../../select/CustomSelect1";
import {IsPopupActiveContext, IsPopupActiveSecondContext} from "../PopupList";
import {CustomSelect} from '../../customSelect/CustomSelect';
import {PhoneCodes} from "../../../constants/PhoneCodes";
import {EmployeesStatus} from "../../../constants/EmployeesStatus";
import {PopupCloseCancel} from "./PopupCloseCancel";
import {PopupClose} from "./PopupClose";
import {useMask} from "@react-input/mask";
import {SetEmployees} from "../../../api/SetEmployees";
import {Translate} from "../../translate/Translate";
import {PopupContext} from "../../../App";
import SimpleBar from "simplebar-react";
import {toast} from "react-toastify";

interface IPopupEditEmployeeProps {
    setIsOpenProjects: any
    data: any
    chosenProjects: IProject[]
    popup: any
    chosenDepartments: any
    setChosenProjects: any
    setChosenDepartments: any
    setSelectedManagers: any
    selectedManagers: string[]
    allManagers: any
}

export const PopupEditEmployee: React.FC<IPopupEditEmployeeProps> = ({
                                                                         setIsOpenProjects,
                                                                         data,
                                                                         setChosenProjects,
                                                                         setChosenDepartments,
                                                                         chosenDepartments,
                                                                         chosenProjects,
                                                                         popup,
                                                                         allManagers,
                                                                         selectedManagers,
                                                                         setSelectedManagers
                                                                     }) => {

    const projects: IProject[] = useSelector((state: any) => state.toolkit.projects)
    const departments: IDepartment[] = useSelector((state: any) => state.toolkit.departments)
    const setIsPopupActive: any = useContext(IsPopupActiveContext)
    const setIsPopupSecondActive: any = useContext(IsPopupActiveSecondContext)

    const allSelectedDepartmentsId = chosenDepartments.reduce((arr: any, curr: any) => {
        arr.push(curr.id)

        return arr
    }, [])

    // Only non-archived projects from the user's departments
    const allProjectsFromDepartments = projects.filter(item =>
        !item.archive && allSelectedDepartmentsId.some((item2: string) => item2 === item.department.id)
    );
    
    // Active chosen projects that belong to the user's departments
    const activeChosenProjects = chosenProjects.filter((cp: any) =>
        allProjectsFromDepartments.some((ap: any) => ap.id === cp.id)
    );

    const dispatch = useDispatch()

    const [firstNameValue, setFirstNameValue] = useState<string>('')
    const [lastNameValue, setLastNameValue] = useState<string>('')
    const [roleValue, setRoleValue] = useState<string>('')
    const [statusValue, setStatusValue] = useState(EmployeesStatus().filter(item => item?.value === data?.status)[0])
    const [emailValue, setEmailValue] = useState<string>('')
    const [phoneValue, setPhoneValue] = useState<string>('')
    const [phoneCode, setPhoneCode] = useState<ISelect>()

    useEffect(() => {
        setFirstNameValue(data?.first_name)
        setLastNameValue(data?.last_name)
        setRoleValue(data?.role)
        setEmailValue(data?.email)
        setPhoneValue(data?.phone.slice(data?.phone.indexOf(" ") + 1))
        setStatusValue(EmployeesStatus().filter(item => item?.value === data?.status)[0])
        setPhoneCode(PhoneCodes().filter(item => item.label === data?.phone.slice(0, data?.phone.indexOf(" ")))[0])
        setSelectedManagers(data.all_managers ? allManagers.map((item: any) => item.id) : data.managers.map((item: any) => item.manager.id))
        setChosenProjects(data.projects)
    }, [data])


    const handleChange = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        const newDataEmployee = {
            "first_name": firstNameValue.trim(),
            "last_name": lastNameValue.trim(),
            "role": roleValue.trim(),
            "status": statusValue.value.trim(),
            "email": emailValue.trim().toLowerCase(),
            "phone": phoneValue ? `${phoneCode?.label} ${phoneValue}` : "",
            "projects": chosenProjects.map((item: any) => item.id),
            // "all_projects": chosenProjects?.length === projects?.length,
            "all_projects": chosenProjects?.length === allProjectsFromDepartments?.length,
            "departments": chosenDepartments.map((item: any) => item.id),
            "all_departments": chosenDepartments?.length === departments.length,
            "managers": selectedManagers,
            "all_managers": selectedManagers.length === allManagers.length
        }

        getBearer('patch')
        axios.patch(getApiLink("/api/admin/employee/edit/?employee_id=" + data.id), newDataEmployee).then(({data}) => {
            if (data.message === "user_exists") {
                return toast.error(<Translate>user_exist</Translate>);
            }

            if (!data.status) return;

            setIsPopupActive(false)
            SetEmployees(dispatch)
        }).catch(er => console.log(getApiLink("/api/admin/employee/edit/"), er))
    }

    const inputRef = useMask({mask: '__ ___ __ __', replacement: {_: /\d/}});

    const setPopup: any = useContext(PopupContext)

    const handleChangePassword = () => {
        setIsPopupSecondActive(true)
        setPopup({
            popup: popup.popup,
            secondPopup: "reset-password-popup",
            data: data
        })
    }

    useEffect(() => {
        setPhoneCode({
            label: data.phone.slice(0, data.phone.indexOf(" ")),
            value: data.phone.slice(0, data.phone.indexOf(" "))
        })
    }, [data])
    
    

    return (
        <div className="add-new-employee__body popup-body">
            <h2 className="popup-title title">
                <Translate>employees_admin.others.edit_employee</Translate>
            </h2>
            <PopupClose/>
            <SimpleBar autoHide={false} className="add-new-employee__container popup-container">
                <form onSubmit={handleChange} className="popup-form">
                    <div className="popup-form__row">
                        <label className="popup-form__label">
                            <span>
                                <Translate>employees_admin.others.first_name</Translate>
                            </span>
                            <input onChange={e => setFirstNameValue(e.target.value)} autoComplete="off"
                                   value={firstNameValue} type="text"
                                   required name={"tick"} id={"tick"} className="input"/>
                        </label>
                        <label className="popup-form__label">
                            <span>
                                <Translate>employees_admin.others.last_name</Translate>
                            </span>
                            <input onChange={e => setLastNameValue(e.target.value)} autoComplete="off"
                                   value={lastNameValue} type="text"
                                   name={"tick1"} id={"tick1"} required className="input"/>
                        </label>
                    </div>
                    <div className="popup-form__row">
                        <label className="popup-form__label">
                            <span>
                                <Translate>employees_admin.others.position</Translate>
                            </span>
                            <input onChange={e => setRoleValue(e.target.value)} value={roleValue} type="text"
                                   name="role" required className="input"/>
                        </label>
                        <label className="popup-form__label">
                            <span>
                                <Translate>employees_admin.others.category</Translate>
                            </span>
                            <CustomSelect selectValue={statusValue} defaultValue={EmployeesStatus().filter(item => item?.value === data?.status)[0]} setSelectedItem={setStatusValue}
                                          list={EmployeesStatus()}/>
                        </label>
                    </div>
                    <div className="popup-form__row">
                        <label className="popup-form__label">
                            <span>Ema<span className={"delete"}>111</span>il</span>
                            <input onChange={e => setEmailValue(e.target.value)} value={emailValue} type="email"
                                   required className="input"/>
                        </label>
                        <label className="popup-form__label">
                            <span>
                                <Translate>employees_admin.others.password</Translate>
                            </span>
                            <span>
                                <a onClick={handleChangePassword} className="profile__info--button open-popup">
                                    <Translate>reset_password.change_pass</Translate>
                                </a>
                            </span>
                        </label>
                    </div>
                    <div className="popup-form__row">
                        <label className="popup-form__item">
                            <span>
                                <Translate>employees_admin.others.phone_number</Translate>
                            </span>
                            <div className="popup-form__item--row tel-parent">
                                <CustomSelect tabIndex={1} list={PhoneCodes()} setSelectedItem={setPhoneCode} selectValue={phoneCode}
                                              defaultValue={PhoneCodes()[0]}/>
                                <input
                                    onChange={e => setPhoneValue(e.target.value)}
                                    value={phoneValue} ref={inputRef} type="text" name="tel"
                                    className="input"/>
                            </div>
                        </label>
                        <label className="popup-form__label">
                            <span>
                                <Translate>Departments</Translate>
                            </span>
                            <a onClick={_ => setIsOpenProjects((prev: string) => prev !== "departments" ? "departments" : "")}
                               className="popup-form__open-sub-popup open-popup">
                                <span id="checked-projects" data-none-text="None" data-text-1="project"
                                      data-text-2="projects" data-all-text="All projects">
                                    {data?.all_departments && !data?.departments?.length && chosenDepartments?.length === departments?.length ?
                                        <Translate>All departments</Translate> : `${chosenDepartments?.length} departments`}
                                </span>
                                <svg width="10" height="7" viewBox="0 0 10 7">
                                    <use xlinkHref="#drop-down-arrow"></use>
                                </svg>
                            </a>
                        </label>
                    </div>
                    <div className="popup-form__row">
                        <label className="popup-form__label is-full">
                            <span>
                                <Translate>employees_admin.others.projects</Translate>
                            </span>
                            <a onClick={_ => setIsOpenProjects((prev: string) => prev !== "projects" ? "projects" : "")}
                               className="popup-form__open-sub-popup open-popup">
                                <span id="checked-projects">
                                    {(activeChosenProjects?.length === allProjectsFromDepartments?.length && allProjectsFromDepartments?.length > 0) ?
                                        <Translate>All projects</Translate> : `${activeChosenProjects.length} projects`}
                                </span>
                                <svg width="10" height="7" viewBox="0 0 10 7">
                                    <use xlinkHref="#drop-down-arrow"></use>
                                </svg>
                            </a>
                        </label>
                    </div>
                    <div className="popup-form__row">
                        <label className="popup-form__label is-full">
                            <span>
                                Approving Managers
                            </span>
                            <a onClick={_ => setIsOpenProjects("leaders")}
                               className="popup-form__open-sub-popup open-popup">
                                <span id="checked-projects">
                                    {selectedManagers?.length === allManagers.length ?
                                        "All Approving Managers" : `${selectedManagers?.length} `}

                                    {
                                        selectedManagers?.length !== allManagers.length && 'Approving Managers'
                                    }
                                </span>
                                <svg width="10" height="7" viewBox="0 0 10 7">
                                    <use xlinkHref="#drop-down-arrow"></use>
                                </svg>
                            </a>
                        </label>
                    </div>
                    <div className="popup-form__row is-min-gap">
                        <PopupCloseCancel/>
                        <button className="popup-form__submit btn" type="submit">
                            <Translate>employees_admin.others.save</Translate>
                        </button>
                    </div>
                </form>
            </SimpleBar>
        </div>
    )
}
